import request from '@/utils/request'

/**
 * @describe 分页查看生产记录
 * @param areaCodeCity
 * @param areaCodeDistrict
 * @param areaCodeSubdistrict
 * @param villageCode
 * @param entName
 * @param kssj
 * @param jssj
 * @param isShow  是否展示 1-是 0-否
 * @param produceName 生产记录名称
 * @param productName 产品名称
 * @param entProductId 企业产品id
 * @param pageNum 1
 * @param pageSize 20
 */
export function pageProduce(query) {
  return request({
    url: 'pro/pageProduce.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 获取一个生产记录
 * @param produceId
 */
export function getOneProduce(query) {
  return request({
    url: 'pro/getOneProduce.do',
    method: 'GET',
    params: query
  })
}

/**
 * @describe 新增一个生产记录
 * @param entId 企业id
 * @param produceName 生产记录名称
 * @param produceDesc 生产记录描述
 * @param produceTime 生产时间
 * @param entProductId 企业产品id
 * @param entProdBaseId 生产基地id
 * @param standardId 生产标准id
 */
export function saveProduce(query) {
  return request({
    url: 'pro/saveProduce.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 修改一个生产记录
 * @param produceId
 * @param 同上
 */
export function editProduce(query) {
  return request({
    url: 'pro/editProduce.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 删除一个生产记录
 * @param produceId
 */
export function delProduce(query) {
  return request({
    url: 'pro/delProduce.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 获取生产记录下的生产明细
 * @param produceId
 */
export function getProduceDetailsByProduceId(query) {
  return request({
    url: 'pro/getProduceDetailsByProduceId.do',
    method: 'GET',
    params: query
  })
}


/**
 * @describe 展示、屏蔽生产记录
 * @param produceId
 * @param isShow 是否展示 1-是 0-否
 */
export function setIsShowStateForProduce(query) {
  return request({
    url: 'pro/setIsShowStateForProduce.do',
    method: 'GET',
    params: query
  })
}

/**
 * @describe 获取一个生产记录明细
 * @param produceDetailId
 */
export function getOneProduceDetail(query) {
  return request({
    url: 'pro/getOneProduceDetail.do',
    method: 'GET',
    params: query
  })
}

/**
 * @describe 新增一个生产记录明细
 * @param produceId 生产记录id
 * @param optName 操作名称
 * @param optDesc 操作描述
 * @param optTime 操作时间
 * @param image1 图片1
 * @param image2 图片2
 * @param image3 图片3
 * @param soundUrl 声音
 */
export function saveProduceDetail(query) {
  return request({
    url: 'pro/saveProduceDetail.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 修改一个生产记录明细
 * @param produceDetailId
 * @param 同上
 */
export function editProduceDetail(query) {
  return request({
    url: 'pro/editProduceDetail.do',
    method: 'POST',
    data: query
  })
}


/**
 * @describe 删除一个生产记录明细
 * @param produceDetailId
 */
export function delProduceDetail(query) {
  return request({
    url: 'pro/delProduceDetail.do',
    method: 'POST',
    data: query
  })
}



/**
 * @describe 展示、屏蔽生产记录明细
 * @param produceDetailId
 * @param isShow 是否展示 1-是 0-否
 */
export function setIsShowStateForProduceDetail(query) {
  return request({
    url: 'pro/setIsShowStateForProduceDetail.do',
    method: 'GET',
    params: query
  })
}
